import { Badge, Item, ItemContent, ItemHeader, ItemTitle } from '@ibsys/kit';
import { SigmaIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getKmEntityTitle, type KmEntity } from '@/entities/ontology';
import { Tooltip } from '@/shared/ui';

type Props = {
  entity: KmEntity;
  /** Название типа сущности; при отсутствии в справочнике — его код */
  typeName: string;
  /** Название домена; у сущности без домена не задано */
  domainName?: string;
  isActive: boolean;
  onSelect: (id: number) => void;
};

/**
 * Строка списка сущностей: название, признак заданного условия применимости, тип сущности и домен.
 */
export const KmEntityListItem: FC<Props> = ({ entity, typeName, domainName, isActive, onSelect }) => {
  const { t } = useTranslation('kmEntities');

  return (
    <li role="button" tabIndex={-1} onClick={() => onSelect(entity.id)}>
      <Item variant={isActive ? 'muted' : 'outline'} className="hover:bg-muted cursor-pointer">
        <ItemHeader>
          <ItemTitle>
            <span className="whitespace-normal break-words">{getKmEntityTitle(entity)}</span>
            {!!entity.predicate && (
              <Tooltip tooltip={t('predicateMark')}>
                <SigmaIcon className="size-3.5 shrink-0 text-muted-foreground" />
              </Tooltip>
            )}
          </ItemTitle>
        </ItemHeader>
        <ItemContent>
          <div className="flex flex-wrap items-center gap-1.5">
            <Badge variant="secondary" outline>
              {typeName}
            </Badge>
            {/* Сущность без домена относится ко всей модели — бейдж домена ей не рисуем */}
            {domainName && <Badge variant="secondary">{domainName}</Badge>}
          </div>
        </ItemContent>
      </Item>
    </li>
  );
};
